import * as React from "react";
import { SvgProps } from "../../../utils/interfaces";

const InfoCircleSvg: React.FC<SvgProps> = ({
  width,
  height,
  viewBox = "0 0 20 20",
  color = "#236998",
  ...rest
}) => {
  return (
    <svg width={width} height={height} viewBox={viewBox} fill="none" {...rest}>
      <path
        d="M10 20C4.5 20 0 15.5 0 10C0 4.5 4.5 0 10 0C15.5 0 20 4.5 20 10C20 15.5 15.5 20 10 20ZM10 1.66667C5.41667 1.66667 1.66667 5.41667 1.66667 10C1.66667 14.5833 5.41667 18.3333 10 18.3333C14.5833 18.3333 18.3333 14.5833 18.3333 10C18.3333 5.41667 14.5833 1.66667 10 1.66667Z"
        fill={color}
      />
      <path
        d="M9.1667 15C8.83337 15 8.58337 14.8333 8.33337 14.5833C7.9167 14 8.25003 13.1667 9.1667 10.9167C9.33337 10.5833 9.50003 10.1667 9.6667 9.83333C9.33337 10.0833 8.83337 10.0833 8.50003 9.75C8.1667 9.41667 8.1667 8.91667 8.50003 8.58333C8.6667 8.5 9.6667 7.5 10.8334 7.5C11.1667 7.5 11.4167 7.66667 11.6667 7.91667C12.0834 8.5 11.75 9.33333 10.8334 11.5833C10.6667 11.9167 10.5 12.3333 10.3334 12.6667C10.6667 12.4167 11.1667 12.4167 11.5 12.75C11.8334 13.0833 11.8334 13.5833 11.5 13.9167C11.3334 14 10.3334 15 9.1667 15Z"
        fill={color}
      />
      <path
        d="M11.25 6.66663C11.9404 6.66663 12.5 6.10698 12.5 5.41663C12.5 4.72627 11.9404 4.16663 11.25 4.16663C10.5596 4.16663 10 4.72627 10 5.41663C10 6.10698 10.5596 6.66663 11.25 6.66663Z"
        fill={color}
      />
      <path
        d="M11.25 7.08333C10.3334 7.08333 9.58337 6.33333 9.58337 5.41667C9.58337 4.5 10.3334 3.75 11.25 3.75C12.1667 3.75 12.9167 4.5 12.9167 5.41667C12.9167 6.33333 12.1667 7.08333 11.25 7.08333ZM11.25 4.58333C10.75 4.58333 10.4167 4.91667 10.4167 5.41667C10.4167 5.91667 10.75 6.25 11.25 6.25C11.75 6.25 12.0834 5.91667 12.0834 5.41667C12.0834 4.91667 11.75 4.58333 11.25 4.58333Z"
        fill={color}
      />
    </svg>
  );
};

export { InfoCircleSvg };
